
// import { RTCCalling } from './ext/index.esm.js'
import NERTCCalling from './ext/index.esm.js'
import { api } from '@/services'
import Axios from 'axios'
import { Message } from 'iview'

import store from '@/store'

// im 配置文件
const config = (token, appKey, account) => ({
  debug: true,
  appKey: appKey,
  account: account,
  token: token,
  onconnect: onConnect,
  onloginportschange: onLoginPortsChange,
  onwillreconnect: onWillReconnect,
  ondisconnect: onDisconnect,
  onerror: onError,
  onmsg: onmsg
})

function onLoginPortsChange (loginPorts) {
  console.log('当前登录帐号在其它端的状态发生改变了', loginPorts)
  // console.log(111)
  // netcall.hangup()
  // store.commit('prvateConsultation/setShowSaveModal', false)
}

function onConnect () {
  console.log('连接成功')
  store.commit('prvateConsultation/setimOnConnect', true)
}

function onWillReconnect (obj) {
  // 此时说明 SDK 已经断开连接, 请开发者在界面上提示用户连接已断开, 而且正在重新建立连接
  console.log('即将重连')
  console.log(obj.retryCount)
  console.log(obj.duration)
}

function onDisconnect (error) {
  // 此时说明 SDK 处于断开状态, 开发者此时应该根据错误码提示相应的错误信息, 并且跳转到登录页面
  console.log('丢失连接', error)
  if (error) {
    switch (error.code) {
      // 账号或者密码错误, 请跳转到登录页面并提示错误
      case 302:
        console.log('账号或者密码错误, 请跳转到登录页面并提示错误')
        break
      // 重复登录, 已经在其它端登录了, 请跳转到登录页面并提示错误
      case 417:
        console.log('重复登录, 已经在其它端登录了')
        break
      // 被踢, 请提示错误后跳转到登录页面
      case 'kicked':
        console.log('被踢, 请提示错误后跳转到登录页面')
        break
      default:
        break
    }
  }
  // store.commit('prvateConsultation/setShowSaveModal', false)
}

function onError (error) {
  console.log('我是错误的', error)
  // store.commit('prvateConsultation/setShowSaveModal', false)
}
function onmsg (message) {
  console.log('我是通话单', JSON.stringify(message))
  // TODO::
  // let params = {
  //   duration: message.attach.duration,
  //   ext: '音视频请求扩展信息',
  //   createtime: message.attach.time,
  //   members: message.attach.accounts,
  //   eventType: message.attach.netcallType,
  //   type: message.attach.type,
  //   channelId: message.attach.channelId,
  //   live: '0',
  //   status: 'SINGLE_PARTICIPATE'
  // }
  // store
  //   .dispatch('prvateConsultation/fetchVideoChannelIdReport', params)
  //   .then(res => {
  //     // 取消呼叫倒计时
  //   })

  // store.commit('prvateConsultation/setShowSaveModal', false)
}

// 初始化 im
const imInit = (token, appKey, account) => {
  var rtc = new NERTCCalling({
    debug: true // 是否需要开启日志，默认开启
  })
  rtc.setupAppKey({
    appKey: appKey
  })
  rtc.login(
    config(token, appKey, account)
  )
  rtc.setTokenService(function (uid) {
    // 自己的获取token逻辑
    return new Promise((resolve, reject) => {
      // if (location.href.indexOf('inquiry.leczcore.com') > 0) {
      //   // 丽兹 不安全模式
      //   resolve(null)
      // }
      api.getYxToken({
        data: {
          app: 2,
          hospitalGuid: store.getters['auth/info'].allHospitalGuid,
          realHospitalGuid: store.getters['auth/info'].allHospitalGuid,
          params: {
            uid: uid
          }
        }
      }).then(res => {
        if (res.code === 0) {
          resolve(res.data.token)
        }
      })
      console.log('获取token')
      // Axios({
      //   method: 'post',
      //   contentType: 'application/json',
      //   url: `https://nrtc.netease.im/demo/getChecksum.action?uid=${uid}&appkey=${appKey}`,
      //   data: {
      //     uid: uid,
      //     appkey: appKey
      //   }
      // }).then(res => {
      //   resolve(res.data.checksum)
      // })
    })
  })
  // 用户接受
  rtc.addDelegate('onUserAccept', (account) => {
    // 点对点呼叫一般在此设置本端视图
    console.log(`用户接受${account}`)
    rtc.getRoomInfo().then(res => {
      store
        .dispatch('prvateConsultation/fetchVideoChannelIdReport', {type: 0, channelId: res.channelId, account: account})
        .then(res => {
        })
      const dom = document.getElementById(`localContainer`)
      rtc.setupLocalView(dom)
    })
  })
  // 用户进入
  rtc.addDelegate('onUserEnter', (account) => {
    console.log(`用户进入${account}`)
    // 群呼一般在此设置远端用户的视图
    const div = document.getElementById(`remoteContainer`)
    rtc.setupRemoteView(account, div)
  })
  rtc.addDelegate('onInvited', () => {
    console.log('收到对方邀请')
    // 一般在此处唤起接听和拒绝按钮，点击后调用rtc.accept接收 或者 rtc.reject拒绝
  })
  rtc.addDelegate('onUserDisconnect', () => {
    console.log('rtc 连接中断')
    Message['error']({
      duration: 3,
      content: '连接中断'
    })
    rtc.hangup()
    store.commit('prvateConsultation/setShowSaveModal', false)
    // 一般在此处唤起接听和拒绝按钮，点击后调用rtc.accept接收 或者 rtc.reject拒绝
  })
  // 对方取消呼叫
  rtc.addDelegate('onUserCancel', () => {
    // do sth
  })

  rtc.addDelegate('onCallingTimeOut', (account) => {
    console.log('邀请超时')
    Message['error']({
      duration: 3,
      content: '邀请超时'
    })
    store.commit('prvateConsultation/setShowSaveModal', false)
  })
  // 用户拒绝
  rtc.addDelegate('onUserReject', (account) => {
    console.log('用户拒绝')
    // do sth
    Message['error']({
      duration: 3,
      content: '用户拒绝'
    })
    rtc.getRoomInfo().then(res => {
      store
        .dispatch('prvateConsultation/fetchVideoChannelIdReport', {type: 1, channelId: res.channelId, account: account})
        .then(res => {
        })
      store.commit('prvateConsultation/setShowSaveModal', false)
    })
  })
  // 用户离开
  rtc.addDelegate('onUserLeave', (account) => {
    console.log('用户离开')
    // do sth
    rtc.getRoomInfo().then(res => {
      store
        .dispatch('prvateConsultation/fetchVideoChannelIdReport', {type: 2, channelId: res.channelId, account: account})
        .then(res => {
        })
      rtc.hangup()
      store.commit('prvateConsultation/setShowSaveModal', false)
    })
  })
  // 通话结束
  rtc.addDelegate('onCallEnd', () => {
    // do sth
    console.log('通话结束')
    rtc.getRoomInfo().then(res => {
      store
        .dispatch('prvateConsultation/fetchVideoChannelIdReport', {type: 2, channelId: res.channelId, account: account})
        .then(res => {
        })
      store.commit('prvateConsultation/setShowSaveModal', false)
    })
  })
  // 收到远端视频流订阅变更
  rtc.addDelegate('onCameraAvailable', ({ userId: account, available }) => {
    console.log('收到远端视频流订阅变更')
    // do sth
  })
  // 收到远端音频流订阅变更
  rtc.addDelegate('onAudioAvailable', ({ userId: account, available }) => {
    console.log('收到远端音频流订阅变更')
    // do sth
  })
  // 错误监听
  rtc.addDelegate('onError', (error) => {
    console.log('err:' + error)
    // do sth
  })
  return rtc
}
export default {
  imInit
}



// WEBPACK FOOTER //
// ./src/im/nim_v2.js